<div class="banner" [ngClass]="{'info': type === 'info', 'warning': type === 'warning'}">
  <mat-icon *ngIf="type==='warning'" class="material-icons-outlined warning">warning</mat-icon>
  <mat-icon *ngIf="type==='info'" class="material-icons info">information</mat-icon>
  <ng-content></ng-content>
</div>
